import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { Invoice } from 'gung-standard';
import { JeevesInvoiceListTableConfigService } from 'gung-standard-jeeves';
import { SjoborgInvoiceTableComponent } from '../components/sjoborg-invoice-table/sjoborg-invoice-table.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgInvoiceListTableConfigService extends JeevesInvoiceListTableConfigService {
  getLayouts(): ListLayout<Invoice>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SjoborgInvoiceTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Invoice grid'
      }
    ];
  }
}
